import { LoginForm } from "@/components/login-form";
import { authClient } from "@/lib/auth-client";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function LoginPage() {
  const navigate = useNavigate();
  const { data: session, isPending } = authClient.useSession();

  useEffect(() => {
    if (!isPending && session) {
      navigate("/");
    }
  }, [session, isPending, navigate]);
  return (
    <div className="container mx-auto flex h-screen items-center justify-center">
      <LoginForm className="w-full max-w-md" />
    </div>
  );
}

export default LoginPage;
